import ModalPreventNavigation from './ModalPreventNavigation.wrapper';

export default ModalPreventNavigation;
export { ModalPreventNavigation };
